module.exports = __webpack_public_path__ + "1b97067a079069e21fe04e49fb2f1597.png";